<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > Role  </label>
             <CRow >
              <CCol >
              <b-input v-model="form.name" placeholder='' :state="validationName" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback :state="validationName">
              must be filled
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationName">
              Looks Good.
              </b-form-valid-feedback>
              </CCol>
            </CRow>
            
          </CCol> 
          </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Edit</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import roles from '@/services/roles'

export default {
name: 'keperluanmodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id: '',
        name: '',
      }
    }
  },
  computed: {
      validationName() {
        return this.form.name.length > 0 
      },
   },
  mounted(){
    
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_ROLE', (params) => {
      if(params.data){
        roles.getRolebyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.name = res.data.name;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.show = false;
      roles.createRole(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    update(id){
      this.show = false;
      roles.updateRole(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
  }
}
</script>

<style>

</style>